const decisionItemOpen = 'decisionItem_open';
const paragraphOpen = 'paragraph_open';
const paragraphClose = 'paragraph_close';
const inline = 'inline';
function handleParagraphs(acc, token) {
  var _acc;
  /**
   * Traverse up the acc token array, and if a chain of one or more inline tokens are under
   * a decisionItem_open token, then it is considered to be a paragraph_close token within
   * a decision item.
   *
   * This also works for a paragraph_open token as inlineCount would be zero meaning that
   * the conditional applies to when decisionItem_open is right above paragraph_open.
   */

  let inlineCount = 0;
  let inlineChainEnded = false;
  for (let i = acc.length - 1; i >= 0; i--) {
    var _acc$i;
    const type = (_acc$i = acc[i]) === null || _acc$i === void 0 ? void 0 : _acc$i.type;
    if (!inlineChainEnded) {
      if (type === inline) {
        inlineCount += 1;
      } else {
        inlineChainEnded = true;
      }
    }
  }
  const isWithinDecisionItem = ((_acc = acc[acc.length - (inlineCount + 1)]) === null || _acc === void 0 ? void 0 : _acc.type) === decisionItemOpen;
  if (!isWithinDecisionItem) {
    acc.push(token);
  }
}
export default function (md, idMap) {
  md.core.ruler.after('custom-block', 'decision-list', function (state) {
    state.tokens = state.tokens.reduce((acc, token, index) => {
      const {
        type
      } = token;
      if (type === paragraphOpen || type === paragraphClose) {
        handleParagraphs(acc, token);
      } else {
        acc.push(token);
      }
      return acc;
    }, []);
  });
}